import { render, staticRenderFns } from "./DialogPageArticle.vue?vue&type=template&id=0b1cc96a&scoped=true&"
import script from "./DialogPageArticle.vue?vue&type=script&lang=js&"
export * from "./DialogPageArticle.vue?vue&type=script&lang=js&"
import style0 from "./DialogPageArticle.vue?vue&type=style&index=0&id=0b1cc96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1cc96a",
  null
  
)

export default component.exports